function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as e } from "./index.es33.js";
import { clsx as o } from "./index.es105.js";
import { Typography as n } from "./index.es35.js";
import "./index.es36.js";
import r from "./index.es111.js";
import s from "./index.es653.js";

var h = function h(_ref) {
  var _o2;

  var a = _ref.label,
      i = _ref.isDisabled,
      t = _ref.isError,
      p = _ref.children;
  return e.jsx("div", {
    className: o(s.inputWrapper, _defineProperty({}, s.inputWrapperDisabled, !!i)),
    children: e.jsxs("label", {
      className: o(r.container, (_o2 = {}, _defineProperty(_o2, r.containerDisabled, i), _defineProperty(_o2, r.containerWithError, t), _o2)),
      children: [a && e.jsx(n.Body2, {
        className: o(r.labelContainer, r.label),
        children: a
      }), p]
    })
  });
};

export { h as PickerWrapper };